import { render, staticRenderFns } from "./OrderReviewCartDetailsLine.vue?vue&type=template&id=479d70d6&scoped=true&"
import script from "./OrderReviewCartDetailsLine.vue?vue&type=script&lang=js&"
export * from "./OrderReviewCartDetailsLine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479d70d6",
  null
  
)

export default component.exports